import {Craft} from "../craft/craft";
import {Company} from "../company/company";
import {TranslateService} from "@ngx-translate/core";
export class Orders {
  Data: Order[];
  Count: number;
}

export class Order {
  Id?: number;
  Uid?: string;
  SUid?: string;
  Craft?: Craft;
  Company?: Company;
  Description1?: string;
  Description2?: string;
  Contract?: string;
  Date?: string;
  Acceptance?: string;
  Warranty?: string;
  IsActive?: boolean;
  IsDeleted?: boolean;
  Project?: any;

  constructor(order: Order = {}) {
    this.Id = order.Id;
    this.Uid = order.Uid;
    this.SUid = order.SUid;
    this.Craft = new Craft(order.Craft);
    this.Company = order.Company;
    this.Description1 = order.Description1;
    this.Description2 = order.Description2;
    this.Contract = order.Contract;
    this.Date = order.Date;
    this.Acceptance = order.Acceptance;
    this.Warranty = order.Warranty;
    this.IsActive = order.IsActive;
    this.IsDeleted = order.IsDeleted;
  }
}

export function getOrderInfo(o: Order, c: Company, translateService: TranslateService) {
  if(o.IsDeleted || (c?.IsDeleted ?? false)) {
    return " " + translateService.instant("MM.general.deleted");
  }
  if(!o.IsActive || (c?.IsInsolvent ?? false)) {
    return " " + translateService.instant("MM.general.inactive");
  }
  return "";
}

